import React from "react";
import { getIconByName } from "../../utils/IconMap";

/**
 * Dynamic Icon Component - Renders icon from pack+name format
 * @param {object} icon - { pack: "fi", name: "FiUser" } or "FiUser"
 * @param {string} className - CSS classes
 * @param {object} style - Inline styles
 */
function DynamicIcon({ icon, className = "", style = {} }) {
    const IconComponent = getIconByName(icon);

    if (!IconComponent) {
        return null;
    }

    return <IconComponent className={className} style={style} />;
}

export default DynamicIcon;
